import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { TBotItem } from '@core/interfaces/TBotItem';

import { BotConfigHistoryModalComponent } from '../../../../../routes/components/modals/bot-config-history-modal/bot-config-history-modal.component';
import { BotEditModalComponent } from '../../../../../routes/components/modals/bot-edit-modal/bot-edit-modal.component';
import { ConfirmationModalComponent } from '../../../../../routes/components/modals/confirmation-modal/confirmation-modal.component';
import { DuplicateBotModalComponent } from '../../../../../routes/components/modals/duplicate-bot-modal/duplicate-bot-modal.component';
import { PromptHintsModalComponent } from '../../../../../routes/components/modals/propmt-hints-modal/prompt-hints-modal.component';
import { BotsService } from '@shared/services/bots.service';
import { CommonService } from '@shared/services/common.service';

import { CustomButtonComponent } from '../message-controls/custom-button/custom-button.component';

@Component({
    selector: 'app-welcome-message',
    templateUrl: './welcome-message.component.html',
    styleUrls: ['./welcome-message.component.scss'],
    standalone: true,
    imports: [CustomButtonComponent]
})
export class WelcomeMessageComponent {
  @Input({ required: true }) agent: TBotItem | null = null;

  constructor(
    private _dialog: MatDialog,
    private _commonService: CommonService,
    private _botsService: BotsService
  ) {}

  protected onPromptHints(): void {
    this._dialog.open(PromptHintsModalComponent, { data: { bot: this.agent } });
  }

  protected onHistory(): void {
    this._dialog.open(BotConfigHistoryModalComponent, {
      data: { bot: this.agent },
      width: '80vw',
      height: '100vh',
      maxWidth: '80vw',
      maxHeight: '100vh',
      position: { right: '0' },
      panelClass: 'bot-config-history-modal',
      hasBackdrop: true,
      disableClose: false,
    });
  }

  protected onDuplicate(): void {
    this._dialog.open(DuplicateBotModalComponent, { data: { bot: this.agent } });
  }

  protected onEdit(): void {
    this._dialog
      .open(BotEditModalComponent, {
        data: this.agent,
        width: '80vw',
        height: '100vh',
        maxWidth: '80vw',
        maxHeight: '100vh',
        position: { right: '0' },
        panelClass: 'bot-edit-modal',
        hasBackdrop: true,
        disableClose: false,
      })
      .componentInstance.saveCallback.subscribe((updated: TBotItem) => {
        // Merge the backend response into the existing agent to preserve
        // formatted fields (type, botCreatorId, title, icon, etc.) that
        // formatBot() sets but the raw backend response lacks.
        this.agent = {
          ...this.agent!,
          ...updated,
          type: this.agent!.type,
          botType: this.agent!.botType,
          botCreatorId: this.agent!.botCreatorId,
          title: updated.name || updated.title || this.agent!.title,
          icon: this.agent!.icon,
          __type: this.agent!.__type,
        };
      });
  }

  protected onDelete(): void {
    const dialogRef = this._dialog.open(ConfirmationModalComponent, {
      data: { text: `Are you sure you want to delete "${this.agent!.title}"?` },
    });
    const dialogSubscription = dialogRef.componentInstance.actionCallback.subscribe(() => {
      this._botsService.deleteBot(this.agent!._id, () => {
        dialogRef.close();
        this._commonService.openSuccessSnackBar(`Bot ${this.agent!.title} was deleted`);
      });
      dialogSubscription.unsubscribe();
    });
  }
}
